import { p } from "./_helpers";

const tourisme = {
 slug: "tourisme",
 path: "/secteurs/tourisme",
 hero: {
 image: "/photos/sector-tourisme-hero.jpg",
 alt: p("Guinée-Bissau, art de vivre et destinations", "Guinea-Bissau, lifestyle and destinations", "Guiné-Bissau, arte de viver e destinos"),
 breadcrumb: p("Tourisme", "Tourism", "Turismo"),
 title: p("Investir dans le tourisme d'expérience.", "Investing in experiential tourism.", "Investir no turismo de experiência."),
 subtitle: p(
 "L'archipel des Bijagós, la culture Balante, la Guinée-Bissau voisine : un tourisme d'auteur à structurer.",
 "The Bijagós archipelago, Balante culture, neighbouring Guinée-Bissau: an authored tourism to structure.",
 "O arquipélago dos Bijagós, a cultura Balanta, a Guiné-Bissau vizinha: um turismo de autor a estruturar."
 ),
 },
 seo: {
 title: p(
 "Investir dans le tourisme en Guinée-Bissau | NANDA SÁ",
 "Investing in tourism in Guinea-Bissau | NANDA SÁ",
 "Investir no turismo na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama du tourisme en Guinée-Bissau : archipel des Bijagós, culture, écotourisme, hôtellerie. Chiffres clés, opportunités, défis et passerelles NANDA SÁ.",
 "Panorama of tourism in Guinea-Bissau: Bijagós archipelago, culture, ecotourism, hospitality. Key figures, opportunities, challenges and NANDA SÁ pathways.",
 "Panorama do turismo na Guiné-Bissau: arquipélago dos Bijagós, cultura, ecoturismo, hotelaria. Dados-chave, oportunidades, desafios e pontes NANDA SÁ."
 ),
 keywords: "tourisme Guinée-Bissau, Bijagós, écotourisme Afrique de l'Ouest, hôtellerie Bissau, tourisme culturel Guinée-Bissau",
 },
 presentation: {
 title: p("Un territoire d'exception, encore confidentiel.", "An exceptional territory, still confidential.", "Um território de excepção, ainda confidencial."),
 paragraphs: p(
 [
 "La Guinée-Bissau possède ce que les destinations mûres n'ont plus : un territoire préservé, une culture vivante et une confidentialité rare. L'archipel des Bijagós, classé Réserve de biosphère par l'UNESCO, en est le joyau. La culture Balante, le patrimoine architectural portugais et la proximité des sites de mémoire coloniale portugaise complètent l'offre.",
 "Le pays reçoit encore peu de visiteurs internationaux, ce qui est à la fois une contrainte et une opportunité : la place est à prendre pour bâtir un tourisme d'auteur, écoresponsable et à forte valeur ajoutée, très éloigné du tourisme de masse.",
 ],
 [
 "Guinea-Bissau has what mature destinations no longer have: a preserved territory, a living culture and a rare confidentiality. The Bijagós archipelago, a UNESCO Biosphere Reserve, is the jewel. Balante culture, Portuguese architectural heritage and proximity to Bissau-Guinean Guinée-Bissau complete the offer.",
 "The country still receives few international visitors, which is both a constraint and an opportunity: the field is open to build an authored, eco-responsible and high-value-added tourism, far from mass tourism.",
 ],
 [
 "A Guiné-Bissau tem o que os destinos maduros já não têm: um território preservado, uma cultura viva e uma confidencialidade rara. O arquipélago dos Bijagós, Reserva da Biosfera da UNESCO, é a jóia. A cultura Balanta, o património arquitectónico português e a proximidade dos sítios de memória colonial portuguesa completam a oferta.",
 "O país ainda recebe poucos visitantes internacionais, o que é ao mesmo tempo uma limitação e uma oportunidade: o espaço está aberto para construir um turismo de autor, ecoresponsável e de forte valor acrescentado, longe do turismo de massas.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés du tourisme", "Tourism key figures", "Dados-chave do turismo"),
 items: [
 { n: "88", l: p("Îles aux Bijagós", "Bijagós islands", "Ilhas dos Bijagós"), d: p("Dont ~20 habitées, ~10 accessibles aux visiteurs.", "Of which ~20 inhabited, ~10 accessible.", "Das quais ~20 habitadas, ~10 acessíveis.") },
 { n: "UNESCO", l: p("Réserve de biosphère", "Biosphere Reserve", "Reserva da Biosfera"), d: p("Statut international protégeant l'archipel.", "International status protecting the archipelago.", "Estatuto internacional que protege o arquipélago.") },
 { n: "< 60 000", l: p("Visiteurs internationaux / an", "International visitors / year", "Visitantes internacionais / ano"), d: p("Marché largement inexploité comparé aux voisins.", "Largely untapped market vs. neighbours.", "Mercado largamente por explorar face aos vizinhos.") },
 { n: "350 km", l: p("De côte atlantique", "Of Atlantic coastline", "De costa atlântica"), d: p("Plages, mangroves, estuaires.", "Beaches, mangroves, estuaries.", "Praias, mangais, estuários.") },
 { n: "30+", l: p("Groupes ethniques", "Ethnic groups", "Grupos étnicos"), d: p("Balante, Fula, Manjaque, Bijago, Papel...", "Balante, Fula, Manjaque, Bijago, Papel...", "Balanta, Fula, Manjaco, Bijagó, Papel...") },
 { n: "2h", l: p("De Bissau en avion", "From Bissau by plane", "De Bissau de avião"), d: p("Positionnement stratégique pour la clientèle diaspora et euro.", "Strategic positioning for diaspora and Euro clients.", "Posicionamento estratégico para a diáspora e clientes europeus.") },
 ],
 sources: p(
 "Sources : UNESCO, IBAP (Institut de la biodiversité), ministère du Tourisme de la Guinée-Bissau, OMT, données 2023-2025.",
 "Sources: UNESCO, IBAP (Institute of Biodiversity), Guinea-Bissau Ministry of Tourism, UNWTO, data 2023-2025.",
 "Fontes: UNESCO, IBAP (Instituto da Biodiversidade), Ministério do Turismo da Guiné-Bissau, OMT, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments de tourisme d'auteur, tous respectueux du territoire et à forte valeur ajoutée par visiteur.",
 "Four segments of authored tourism, all respectful of the territory and with high value added per visitor.",
 "Quatro segmentos de turismo de autor, todos respeitosos do território e de forte valor acrescentado por visitante."
 ),
 segments: [
 { h3: p("1. Écolodges et hôtellerie de charme aux Bijagós", "1. Ecolodges and boutique hotels in Bijagós", "1. Ecolodges e hotelaria de charme nos Bijagós"),
 p: p("Petites unités 8-20 clés, architecture locale contemporaine, offre haut de gamme. Ticket : 400 000 à 2 M€. ROI 6-9 ans avec bon positionnement.", "Small 8-20 room units, contemporary local architecture, high-end offer. Ticket: €400k to €2M. ROI 6-9 years with good positioning.", "Pequenas unidades de 8-20 chaves, arquitectura local contemporânea, oferta de alta gama. Ticket: 400 000 a 2 M€. ROI 6-9 anos com bom posicionamento.") },
 { h3: p("2. Tourisme culturel & communautaire", "2. Cultural & community tourism", "2. Turismo cultural e comunitário"),
 p: p("Immersions Balante, festivals, artisanat, cuisine créole. Modèle coopératif et rentable à petite échelle. Ticket : 30 000 à 150 000 €.", "Balante immersions, festivals, crafts, Creole cuisine. Cooperative model profitable at small scale. Ticket: €30k to €150k.", "Imersões Balanta, festivais, artesanato, cozinha crioula. Modelo cooperativo rentável em pequena escala. Ticket: 30 000 a 150 000 €.") },
 { h3: p("3. Écotourisme, ornithologie et pêche sportive", "3. Ecotourism, birdwatching, sport fishing", "3. Ecoturismo, observação de aves, pesca desportiva"),
 p: p("Les Bijagós abritent tortues marines, hippopotames marins, plus de 200 espèces d'oiseaux. Marché de niche premium, clientèle européenne et américaine.", "Bijagós host sea turtles, marine hippos, 200+ bird species. Premium niche market, European and American clientele.", "Os Bijagós albergam tartarugas marinhas, hipopótamos marinhos, 200+ espécies de aves. Nicho premium, clientela europeia e americana.") },
 { h3: p("4. Hôtellerie & restauration à Bissau", "4. Hospitality & restaurants in Bissau", "4. Hotelaria e restauração em Bissau"),
 p: p("Réponse au manque criant d'offre urbaine qualitative pour les délégations, ONG, hommes d'affaires. Ticket : 200 000 à 1 M€.", "Response to the striking lack of quality urban offer for delegations, NGOs, business travellers. Ticket: €200k to €1M.", "Resposta à falta de oferta urbana qualitativa para delegações, ONG, homens de negócios. Ticket: 200 000 a 1 M€.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "Le tourisme guinéen est en construction. Y entrer aujourd'hui suppose de connaître honnêtement ses freins actuels.",
 "Guinean tourism is under construction. Entering it today requires an honest understanding of its current constraints.",
 "O turismo guineense está em construção. Entrar hoje exige um conhecimento honesto dos seus constrangimentos actuais."
 ),
 items: p(
 [
 "Une desserte aérienne encore limitée, principalement via Bissau ou Lisbonne.",
 "Un cadre réglementaire touristique en évolution (licences hôtelières, agréments).",
 "Une chaîne logistique fragile pour l'approvisionnement des îles.",
 "Un besoin fort de formation locale (accueil, service, langues).",
 "Une communication internationale à construire face à des voisins mieux positionnés.",
 ],
 [
 "Still limited air access, mainly via Bissau or Lisbon.",
 "An evolving tourism regulatory framework (hotel licences, permits).",
 "A fragile supply chain for the islands.",
 "A strong need for local training (reception, service, languages).",
 "International communication to build vs. better-positioned neighbours.",
 ],
 [
 "Uma acessibilidade aérea ainda limitada, principalmente via Bissau ou Lisboa.",
 "Um enquadramento regulatório turístico em evolução (licenças hoteleiras, autorizações).",
 "Uma cadeia logística frágil para o abastecimento das ilhas.",
 "Uma forte necessidade de formação local (acolhimento, serviço, línguas).",
 "Uma comunicação internacional a construir face a vizinhos mais bem posicionados.",
 ]
 ),
 closing: p(
 "Ces défis sont, pour un opérateur exigeant, autant de barrières à l'entrée qui protégeront son investissement à moyen terme.",
 "For a demanding operator, these challenges are entry barriers that will protect the investment in the medium term.",
 "Para um operador exigente, estes desafios são barreiras à entrada que protegerão o investimento a médio prazo."
 ),
 },
 pourquoi: {
 title: p("NANDA SÁ, ancrage local et regard international.", "NANDA SÁ, local roots and international outlook.", "NANDA SÁ, ancoragem local e olhar internacional."),
 paragraphs: p(
 [
 "Nous connaissons le territoire, la langue, les communautés, les institutions. Nous connaissons aussi les standards internationaux de l'hôtellerie et du tourisme culturel. Notre pôle Conseil en implantation accompagne les investisseurs touristiques dans le montage complet de leur projet.",
 "Nous entretenons des relations avec les autorités touristiques, les communautés locales des Bijagós et les acteurs des Bijagós et des régions nord de la Guinée-Bissau, qui permettent d'ouvrir des portes rarement accessibles.",
 ],
 [
 "We know the territory, the language, the communities, the institutions. We also know the international standards of hospitality and cultural tourism. Our Establishment Advisory supports tourism investors in the full structuring of their project.",
 "We maintain relationships with tourism authorities, Bijagós local communities and Bissau-Guinean Guinée-Bissau stakeholders that open doors rarely accessible.",
 ],
 [
 "Conhecemos o território, a língua, as comunidades, as instituições. Conhecemos também os padrões internacionais da hotelaria e do turismo cultural. A nossa Consultoria de implantação acompanha os investidores turísticos na estruturação completa do seu projecto.",
 "Mantemos relações com as autoridades turísticas, as comunidades locais dos Bijagós e os actores dos Bijagós e das regiões norte da Guiné-Bissau, que permitem abrir portas raramente acessíveis.",
 ]
 ),
 bullets: p(
 [
 "Étude de faisabilité hôtelière ou d'écolodge",
 "Identification du foncier (îles et continent)",
 "Démarches administratives et licences touristiques",
 "Recrutement, formation, cadre managérial",
 "Mise en relation avec agences réceptives et distributeurs internationaux",
 ],
 [
 "Hotel or ecolodge feasibility study",
 "Land identification (islands and mainland)",
 "Administrative procedures and tourism licences",
 "Recruitment, training, managerial framework",
 "Connection with inbound agencies and international distributors",
 ],
 [
 "Estudo de viabilidade hoteleira ou de ecolodge",
 "Identificação de terrenos (ilhas e continente)",
 "Diligências administrativas e licenças turísticas",
 "Recrutamento, formação, enquadramento gestor",
 "Ligação com agências receptivas e distribuidores internacionais",
 ]
 ),
 },
 download: {
 title: p(
 "Télécharger la note « Tourisme · Guinée-Bissau ».",
 "Download the brief « Tourism · Guinea-Bissau ».",
 "Descarregar a nota « Turismo · Guiné-Bissau »."
 ),
 body: p(
 "Une note de synthèse préparée par NANDA SÁ : chiffres clés, segments d'investissement, cadre réglementaire et contacts utiles.",
 "A concise brief prepared by NANDA SÁ: key figures, investment segments, regulatory framework and useful contacts.",
 "Uma nota de síntese preparada pela NANDA SÁ: dados-chave, segmentos de investimento, enquadramento regulatório e contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-tourisme.pdf",
 pdfFilename: "nanda-sa-note-tourisme.pdf",
 mailSubject: p("Téléchargement de la note « Tourisme · Guinée-Bissau »", "Download of the brief « Tourism · Guinea-Bissau »", "Descarga da nota « Turismo · Guiné-Bissau »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Tourisme · Guinée-Bissau ». Merci de me tenir informé(e) des prochaines publications de NANDA SÁ.",
 "Hello, I would like to receive the brief « Tourism · Guinea-Bissau ». Please keep me informed of NANDA SÁ's next publications.",
 "Olá, gostaria de receber a nota « Turismo · Guiné-Bissau ». Por favor, mantenha-me informado(a) das próximas publicações da NANDA SÁ."
 ),
 },
 contact: {
 title: p("Parlons de votre projet touristique.", "Let's talk about your tourism project.", "Falemos do seu projecto turístico."),
 body: p(
 "Hôtelier, opérateur d'écolodge, tour-opérateur, investisseur, institution : décrivez votre intention, nous répondons personnellement.",
 "Hotelier, ecolodge operator, tour operator, investor, institution: describe your intention, we respond personally.",
 "Hoteleiro, operador de ecolodge, tour operador, investidor, instituição: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Les meilleures destinations sont celles qui, un instant encore, ont l'air d'être un secret.",
 "The best destinations are those that, for another moment, still feel like a secret.",
 "Os melhores destinos são aqueles que, por mais um instante, ainda parecem um segredo."
 ),
 subject: p("Investir dans le tourisme en Guinée-Bissau", "Invest in tourism in Guinea-Bissau", "Investir no turismo na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default tourisme;
